const keyboardKeys = {
  ENTER: 'Enter',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_LEFT: 'ArrowLeft',
  ESCAPE: 'Escape',
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  TAB: 'Tab',
  SPACE: ' ',
} as const;

// Navigation keys for CustomDropdown component
export const CUSTOM_DROPDOWN_NAVIGATION_KEYS = [
  keyboardKeys.ARROW_UP,
  keyboardKeys.ARROW_DOWN,
  keyboardKeys.ENTER,
  keyboardKeys.SPACE,
  keyboardKeys.ESCAPE,
  keyboardKeys.TAB,
] as const;

export default keyboardKeys;
